export enum QueuePriorityEnum {
  High = 1,
  Normal,
  Low
}
